export var CompleteSetupStepId;
(function (CompleteSetupStepId) {
    CompleteSetupStepId["DEFAULT"] = "DEFAULT";
    CompleteSetupStepId["ACTIVATE_TRIAL"] = "ACTIVATE_TRIAL";
    CompleteSetupStepId["SECOND_BANK_ACCOUNT"] = "SECOND_BANK_ACCOUNT";
    CompleteSetupStepId["SET_UP_BUDGETING"] = "SET_UP_BUDGETING";
    CompleteSetupStepId["START_INVESTING"] = "START_INVESTING";
    CompleteSetupStepId["START_SAVING"] = "START_SAVING";
    CompleteSetupStepId["CREDIT_SCORE"] = "CREDIT_SCORE";
    CompleteSetupStepId["RENT_REPORTING"] = "RENT_REPORTING";
    CompleteSetupStepId["FRAUD_DETECTION"] = "FRAUD_DETECTION";
})(CompleteSetupStepId || (CompleteSetupStepId = {}));
export var EmmaSetUpStepId;
(function (EmmaSetUpStepId) {
    EmmaSetUpStepId["REVIEW_BANK_ACCOUNTS"] = "REVIEW_BANK_ACCOUNTS";
    EmmaSetUpStepId["SETUP_BUDGET"] = "SETUP_BUDGET";
    EmmaSetUpStepId["MANAGE_SUBSCRIPTIONS"] = "MANAGE_SUBSCRIPTIONS";
    EmmaSetUpStepId["BUILD_CREDIT_HISTORY"] = "BUILD_CREDIT_HISTORY";
    EmmaSetUpStepId["UNLOCK_NETWORTH"] = "UNLOCK_NETWORTH";
    EmmaSetUpStepId["EARN_CASHBACK"] = "EARN_CASHBACK";
    EmmaSetUpStepId["GROW_YOUR_SAVINGS"] = "GROW_YOUR_SAVINGS";
    EmmaSetUpStepId["OPEN_INVEST"] = "OPEN_INVEST";
    EmmaSetUpStepId["PROTECT_YOUR_IDENTITY"] = "PROTECT_YOUR_IDENTITY";
})(EmmaSetUpStepId || (EmmaSetUpStepId = {}));
export const setUpEmmaStepIds = Object.values(EmmaSetUpStepId);
export const totalSetUpSteps = setUpEmmaStepIds.length;
